<template>
  <b-modal
    :title="'Новая мнемоника'"
    v-model="modalShow"
    size="lg"
    ok-title="Сохранить"
    :ok-disabled="!isValid"
    cancel-title="Отмена"
    @hide.prevent="handleCancel"
    @cancel="handleCancel"
    @close="handleCancel"
    @ok="handleOk"
  >
    <div class="container">
      <div class="row align-items-center">
        <label class="col-3">
          <span class="required-mark">Наименование</span>
        </label>
        <div class="col-9">
          <b-form-input :required="true" v-model.lazy="mnemonicTitle" type="text" />
        </div>
      </div>
      <div class="row align-items-center">
        <label class="col-3">
          <span class="required-mark">Мнемоника</span>
        </label>
        <div class="col-9">
          <b-form-input :required="true" v-model.lazy="mnemonicName" type="text" />
        </div>
      </div>
    </div>
    <vis-confirm-dialog
      :visible="confirmClose.visible"
      :title="confirmClose.title"
      :text="confirmClose.text"
      @acceptChanges="confirmClose.acceptClose"
      @cancelChanges="confirmClose.cancelClose"
      @hideDialog="confirmClose.cancelClose"
    ></vis-confirm-dialog>
  </b-modal>
</template>

<script>
export default {
  name: "vis-mnemonic-create-view",
  props: {
    visible: { type: Boolean, required: true },
    entityType: { type: String, required: true }
  },
  data(vm) {
    return {
      modalShow: this.visible,
      mnemonicTitle: null,
      mnemonicName: null,
      dirty: false,
      confirmClose: {
        visible: false,
        text: "Продолжить без сохранения?",
        title: "Отмена",
        acceptClose() {
          vm.setConfirmDialogVisible(false);
          vm.handleHide();
        },
        cancelClose() {
          vm.setConfirmDialogVisible(false);
        }
      }
    };
  },
  computed: {
    isValid() {
      return (
        this.mnemonicTitle && this.mnemonicTitle.length
      ) && (
          this.mnemonicName && this.mnemonicName.length
        )
    }
  },
  methods: {
    handleOk(e) {
      if (
        this.mnemonicTitle === null ||
        this.mnemonicTitle === "" ||
        this.mnemonicName === null ||
        this.mnemonicName === ""
      ) {
        e.preventDefault();
      } else {
        this.setDirty(false);
        this.$emit("ok", {
          Title: this.mnemonicTitle,
          Mnemonic: this.mnemonicName,
          EntityType: this.entityType
        });
      }
    },
    handleCancel() {
      if (this.dirty) {
        return this.setConfirmDialogVisible(true);
      }
      this.handleHide()
    },
    handleHide() {
      this.$emit("hide");
    },
    setDirty(isDirty) {
      this.dirty = isDirty
    },
    setConfirmDialogVisible(isVisible) {
      this.confirmClose.visible = isVisible
    }
  },
  watch: {
    visible(nv) {
      this.modalShow = nv;
    },
    mnemonicTitle() {
      this.setDirty(true)
    },
    mnemonicName() {
      this.setDirty(true)
    }
  }
};
</script>
